package org.example.site_web.content.page

val projectContent_Part1:String = "Accelarge Innovations porte aujourd'hui le projet Ind&ffi "+
        "et est à ce titre membre de l'incubateur "+
        "EMERGYS soutenu par la région Bretagne et accompagné par Lorient Technopole."


val projectContent_Part2:String = "Ce projet en cours de développement a pour objet le développement "+
        "d'un outil d'assistance numérique semi-autonome destiné aux personnes "+
        "exerçant une activité ou un métier indépendant (artisans, professions de santé à domicile...)."

